module.exports = __webpack_public_path__ + "img/1Fondoportada.5ac39d79.svg";